/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () =>
  chance.pickone([
    {
      id: 1002,
      description: 'All Melbourne VIC',
      shortDescription: 'Melbourne, Victoria',
      countryCode: 'AU',
    },
    {
      id: 5071,
      description: 'Eastern Suburbs Melbourne VIC',
      shortDescription: 'Eastern Suburbs, Victoria',
      countryCode: 'AU',
    },
    {
      id: 5068,
      description: 'South West Coast VIC',
      shortDescription: 'South West Coast VIC, Victoria',
      countryCode: 'AU',
    },
    {
      id: 5026,
      description: 'Albury Area NSW',
      shortDescription: 'Albury Area, New South Wales',
      countryCode: 'AU',
    },
    {
      id: 1019,
      description: 'All Wellington NZ',
      shortDescription: 'Wellington',
      countryCode: 'NZ',
    },
    {
      id: 5161,
      description: 'London UK',
      shortDescription: 'London UK',
      countryCode: 'GB',
    },
    {
      id: 1000132,
      description: 'Kwun Tong Kwun Tong District HK',
      shortDescription: 'Kwun Tong Kwun Tong District HK',
      countryCode: 'HK',
    },
    {
      id: 2030806,
      description: 'Klaten Central Java ID',
      shortDescription: 'Klaten Central Java ID',
      countryCode: 'ID',
    },
    {
      id: 1000178,
      description: 'Johor MY',
      shortDescription: 'Johor MY',
      countryCode: 'MY',
    },
    {
      id: 5118,
      description: 'Auckland Central Auckland NZ',
      shortDescription: 'Auckland Central, Auckland',
      countryCode: 'NZ',
    },
    {
      id: 2060400,
      description: 'Cagayan Valley PH',
      shortDescription: 'Cagayan Valley PH',
      countryCode: 'PH',
    },
    {
      id: 2701201,
      description: 'Ang Mo Kio North-East Region SG',
      shortDescription: 'Ang Mo Kio North-East Region SG',
      countryCode: 'SG',
    },
    {
      id: 2080600,
      description: 'Amnat Charoen TH',
      shortDescription: 'Amnat Charoen TH',
      countryCode: 'TH',
    },
  ]);
